/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Topbar} from './Topbar'

type props = {
  title?: string
}

function HeaderWrapperFluid({title}: props) {
  const {config, classes, attributes} = useLayout()
  const {aside} = config

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}
        {/* begin::Logo */}
        {!aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <Link to='/dashboard' className='d-lg-none'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-30px' />
            </Link>
          </div>
        )}
        {/* end::Logo */}

        {/* begin::Wrapper */}
        <div className='d-flex align-items-center justify-content-between  w-100 '>
          {/* begin::Navbar */}
          <div className='d-flex align-items-center me-4 pt-2' id='kt_header_nav'>
            {/* <h1>{title}</h1> */}
            <div className='aside-logo lg-d-flex align-items-center py-10' id='kt_aside_logo'>
              {title ? <h1>{title}</h1> : <></>}
            </div>
          </div>

          <div className='d-flex align-items-center flex-shrink-0'>
            {/* <ToggleTheme /> */}
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}

export {HeaderWrapperFluid}
